import React from 'react';

import { Popover } from 'antd';

import styled from 'styled-components';

import FlexContainer from '@components/Gui/FlexContainer';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ActionContent = styled.div`
    opacity: ${(props) => (props.permission ? 1 : 0.4)};
    cursor: ${(props) => (props.permission ? 'pointer' : 'not-allowed !important')};

    div,
    svg,
    p,
    a {
        cursor: ${(props) => (props.permission ? 'pointer' : 'not-allowed !important')};
    }
`;

const PermissionBlock = ({ content, permission, placement }) => {
    return permission ? (
        content
    ) : (
        <Popover
            placement={placement ? placement : 'bottom'}
            content={
                <FlexContainer>
                    <NwIcon icon={byPrefixAndName.fasl['lock-alt']} />
                    &nbsp;
                    <div>Your current Netwalk profile is not allowed to access this section</div>
                </FlexContainer>
            }
        >
            <ActionContent permission={permission}>{content}</ActionContent>
        </Popover>
    );
};

export default PermissionBlock;
